const en = {
	task: {
		center: 'Task center',
		callTask: 'Call task',
		giftTask: 'Gift task',
		liveTask: 'Newbie task',
		sevenTask: '7 days task',
		callMessage: 'Receiving more calls to get reward',
		giftMessage: 'Asking gifts to get reward',
		liveMessage:
			"Increasing your <span class='web'>Live</span> time to win {d} reward",
		sevenMessage: 'Finishing daily task to win {d} reward',
		cellTitle: 'Call duration ≥{d} mins (Time)',
		reward: 'Reward',
		lastWeek: "Last week's reward:",
		weekGift: 'Gift revenues of this week:',
		RewardDescription: 'Instructions',
		everyWeekGift: "Weekly gift revenues (<span class='web'>Bonus</span>)",
		endTask: 'Task was over',
		query: 'OK',
		noRecharge:
			"Touch off the platform's risk management,top-up is ubviable for the time being.Any doubts, please contact: Whatsapp：+852 46230653",
	},
	message: {
		taxt1: '1. The settlement cysle is from Monday to Sunday,the more video calls ≥{d} mins,the more reward that you can get.',
		taxt2: "2. Users can only get one rank's reward which according to your maximum number of call duration ≥{d} mins.",
		taxt3: "3. Once it's approved by the official,the reward will remit to your account on next Thursday.",
		taxt4: '4. Cheating accounts cannot share this right.',
		taxt5: "5. If you have any doubts,please contact：<span class='web'>support@honeycamweb.com</span>;",
		hint: 'Note:according to the London time',
		rewardOne1: '1.Within 7 days of the task',
		rewardOne2:
			"1) you have to keep at least 6 days' <span class='web'>live</span>≥2 h ,call completing rate≥{d};",
		rewardOne3:
			"2) Within 7 days of the task,total revenue≥{d}<span class='web'>Bonus</span>;",
		rewardOne4:
			"3) If you meet all of the above requirements,you can win <span style='color: #ff2794'>{d}</span> when the task finished;",
		rewardOne5:
			'2.Each hosts can not reward more than one account, multiple accounts are invalid;',
		rewardOne6:
			"3.Once we detect your cheating behaviour,we'll cancel your reward;",
		rewardOne7:
			"4.Users who finish the task can win <span style='color: #ff2794'>$10</span> if you subscribe official <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> and join the group",
		rewardOne8:
			"5.If you have any doubts,please contact：<span class='web'>support@honeycamweb.com;</span>",
		rewardTwo1:
			'Users who earn more than {d} on that day during the task have the opportunity to go to the hot/recommended page the next day and get more exposure',
	},
	gift: {
		test1: '1. The settlement cysle is from Monday to Sunday,the more more gifts that  you received,the more reward that you can get.',
		test2: "2. Users can only get one rank's reward which according to your total gift revenues.",
		test3: "3. Once it's approved by the official,the reward will remit to your account on next Thursday.",
		test4: '4. Cheating accounts cannot share this right.',
		test5: "5.If you have any doubts,please contact：<span class='web'>support@honeycamweb.com;</span>",
		giftNum: 'The num of gifts≥{d}',
		totalBonus: "Revenues≥{d}<span class='web'>Bonus</span>",
		liveCallTime: "<span class='web'>live</span>≥{d}(m)",
		callTime: 'Call duration≥{d}(m)',
		callRate: '接通率≥{d}%',
	},
	new: {
		rewardOne: '1st Reward',
		rewardTwo: '2nd Reward',
		start: "The task starts at 0 o 'clock today",
		hint: "Keep <span class='web'>Live</span>≥{d} h ,call completing rate≥{d} everyday.Then you can win {d}",
		tastReward:
			"Total <span class='web'>Bonus</span> revenue in task duration",
		liveTime: "Today's <span class='web'>live</span> duration",
		callRate: "Today's call completing rate",
		progress: 'Task progress',
		endRate: '(target≥',
		overText1: 'Congratulations that the task is finished',
		overText2:
			'subscribe official <span class=\'web\'>Facebook "Honeycam"</span> and join the group to get {d} reward',
		overText3:
			"It is a pity that the task was not completed,you can't get {d}.",
		overText4:
			'Subscribe official <span class=\'web\'>Facebook "Honeycam"</span> to get more information of activities.',
		openfb: "Turn on <span class='web'>Facebook</span>",
	},
	week: {
		live30: "<span class='web'>live</span>≥{d} mins tomorrow",
		call5: 'Call duration≥5 mins tomorrow',
		rewardHint:
			"(Finishing all of the following tasks,<span style='color: #ff2794'>there's an extra <span class='web'>$20</span> reward</span>)",
		newLive: "Today's <span class='web'>Live</span> duration",
		newLiveSec: '(target≥{d})',
		newCall: "Today's call duration",
		newCallRate: "Today's call completing rate",
		newBonus: "Today's <span class='web'>Bonus</span> reward",
		newGift: "The num of today's gifts",
		newReward: "Today's reward",
		days: 'Days',
		taskReq: "Task's requirements",
		task1: "1.everyday's tasks are paid at 0 PM and sent to your <span class='web'>Bonus</span> account at 0 PM；(London time);",
		task2: "2.If users don't finish the task on that day,it regards as the task failed.Failed task cannot restart;",
		task3: "3.Users can't get {d} reward ubless you finsh all of your tasks;",
		task4: '4.Each hosts can not reward more than one account, multiple accounts are invalid;',
		task5: "5.Once we detect your cheating behaviour,we'll cancel your reward;",
		task6: "6.sers who finish the task can win <span style='color: #ff2794' class='web'>$20</span> if you subscribe official <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> and join the group;",
		task7: "7.If you have any doubts,please contact：<span class='web'>support@honeycamweb.com</span>",
	},
}

export default en
